import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cpf'
})
export class CpfPipe implements PipeTransform {

  transform(cpf: string): any {
    if (!cpf) {
        return '';
      }
    //console.log('>>>>>>>>> CPF Pipe: ' + cpf);

    //return telefone;
    return cpf.substr(0,3) + '.' + cpf.substr(3,3) + '.' + cpf.substr(6,3) + '-' + cpf.substr(9,2);

  }

}
